import { fillVariants } from "../../../../styles/utils/fill"
import { classNames } from "../../../../utils"
import type { IconProps } from "../../../types"

export const ExploreFilled = ({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) => {
  return (
    <svg
      aria-label="Explore"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m260-260 300-140 140-300-300 140-140 300Zm220-180q-17 0-28.5-11.5T440-480q0-17 11.5-28.5T480-520q17 0 28.5 11.5T520-480q0 17-11.5 28.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  )
}
